import React from 'react';
import Skeleton from '../../../../shared/components/ui/Skeleton/Skeleton';

const TableSkeleton = ({ rows = 6 }) => {
    return (
        <div className="projects-list-container" style={{ padding: '0 2rem' }}>
            <div className="projects-list">
                {[...Array(rows)].map((_, i) => (
                    <div 
                        key={i} 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '1.25rem 0', 
                            borderBottom: '1px solid #f1f5f9',
                            gap: '2rem'
                        }}
                    >
                        <div style={{ flex: '2' }}>
                            <Skeleton variant="text" width="60%" height={16} style={{ marginBottom: '4px' }} />
                        </div>
                        <div style={{ flex: '1.5' }}>
                            <Skeleton variant="text" width="40%" height={14} />
                        </div>
                        <div style={{ flex: '1' }}>
                            <Skeleton variant="rect" width={80} height={24} style={{ borderRadius: '20px' }} />
                        </div>
                        <div style={{ flex: '1' }}>
                            <Skeleton variant="text" width="50%" height={14} />
                        </div>
                        <div style={{ width: '40px' }}>
                            <Skeleton variant="circle" width={24} height={24} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TableSkeleton;
